import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
    const [isMobile, setIsMobile] = useState(
        () => window.innerWidth < breakpoint
    );

    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

        const handleChange = (e) => setIsMobile(e.matches);

        // Modern browsers
        if (mql.addEventListener) {
            mql.addEventListener("change", handleChange);
        } else {
            mql.addListener(handleChange);
        }

        // Sync initial value
        setIsMobile(mql.matches);

        return () => {
            if (mql.removeEventListener) {
                mql.removeEventListener("change", handleChange);
            } else {
                mql.removeListener(handleChange);
            }
        };
    }, [breakpoint]);

    return isMobile;
}
